import { usePlatform } from '@hmhco/platform-helper';
import useHnmSSORedirect from './useHnmSSORedirect.hook';

const useSSORedirect = () => {
  const platform = usePlatform();
  return useHnmSSORedirect(platform);
};

export default useSSORedirect;
